export const trasformTimeframeToOptions = (timeFrame: {
  max_value: number;
  unit: string;
}) => {
  return Array.from({ length: timeFrame.max_value }, (_, i) => ({
    label: `${i + 1} ${timeFrame.unit}${i === 0 ? "" : "s"}`,
    value: i + 1
  }));
};
